import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/client";
// import { GET_ALL_ANSWERS, GET_COMPANY_ANSWERS, GET_LOCATION_ANSWERS } from "../../features/graphql/query";
import { PARENT_DESCRIBE_THEIR_MOOD_ENGLISH_QUESTION_ID, WHO_DO_YOU_LIVE_WITH_ENGLISH_QUESTION_ID } from "../../constants/QuestionIds/english-TweenScreenQuestionIds";

type AnswerQueryType = "locationAnswers" | "companyAnswers" | "answers";
interface AnswerTableData {
    id: string | null,
    questionPosition: string | null,
    screenLanguage: string | null,
    question: string | null,
    questionType: string | null,
    category: string | null,
    data: string | null,
    sentimentAnalysisData: string | null,
    keywordExtractionData: string | null,
}
export interface AnswerContextType {
    answers: AnswerDataType[];
    setAnswers: (answers: AnswerDataType[]) => void;
    answerInfo: AnswerInfoType;
    setAnswerInfo: (data: any) => void;
    id: string | null;
    setId: (value: string) => void;
    // refetchAnswers: (query: string | null | undefined) => void;
}

type AnswerDataType = AnswerTableData | null
interface AnswerInfoType {
    answerQueryType: string;
    totalAnswers: number;
    pageInfo: {
        hasNextPage: boolean,
        hasPreviousPage: boolean,
        startCursor?: string,
        endCursor?: string,
    }
}
const AnswerContext = React.createContext<AnswerContextType | null>(null);
AnswerContext.displayName = "AnswerContext";

function splitCamelCase(str: string) { return str.replace(/([a-z])([A-Z])/g, '$1 $2'); }
export const AnswerProvider = ({ children }: { children: React.ReactNode }) => {
    const [answers, setAnswers] = useState<AnswerDataType[]>([]);
    const [answerInfo, setAnswerInfo] = useState<AnswerInfoType>({
        answerQueryType: "",
        totalAnswers: 0,
        pageInfo: {
            hasNextPage: false,
            hasPreviousPage: false,
            startCursor: "",
            endCursor: ""
        }
    })
    const [id, setId] = useState<string | null>(null);
    let after = null
    // const query = answerInfo.answerQueryType === "locationAnswers" ? GET_LOCATION_ANSWERS : answerInfo.answerQueryType === "companyAnswers" ? GET_COMPANY_ANSWERS : GET_ALL_ANSWERS;
    // const variables = answerInfo.answerQueryType === "locationAnswers" ? { variables: { locationId: id, first: 5 } } : answerInfo.answerQueryType === "companyAnswers" ? { variables: { companyId: id, first: 100 } } : { variables: { first: 100 } }

    // const [getAnswers, { data, loading, refetch }] = useLazyQuery(query, variables);

    // useEffect(() => {
    //     if (answerInfo.answerQueryType.length > 0) {
    //         console.log("trying to get answers")
    //         getAnswers()
    //     }
    //     console.log("outside conditional")
    // }, [answerInfo.answerQueryType])
    // useEffect(() => {
    //     console.log("pulling new data? ", data)
    // }, [data])
    // useEffect(() => {
    //     console.log("the answer info is changing: ", answerInfo)
    // }, [answerInfo])
    // const refetchAnswers = async (query: string | null | undefined) => {
    //     console.log("it made it to the function itself")
    //     console.log(answerInfo)
    //     if (answerInfo.answerQueryType.length < 1) return;
    //     console.log("there are answers")
    //     const pageInfo = data[answerInfo.answerQueryType]?.pageInfo;
    //     if (!pageInfo?.hasNextPage) return; // no more pages
    //     const nextCursor = pageInfo.endCursor;
    //     console.log("Next cursor:", nextCursor);
    //     console.log("there is another page?: ", pageInfo.hasNextPage)
    //     // Build the proper variables object
    //     const variables =
    //         answerInfo.answerQueryType === "locationAnswers"
    //             ? { locationId: id, first: 100, after: nextCursor, query: query }
    //             : answerInfo.answerQueryType === "companyAnswers"
    //                 ? { companyId: id, first: 100, after: nextCursor, query: query }
    //                 : { first: 100, after: nextCursor, query: query };

    //     // Optionally include the query string if needed
    //     // if (query) (variables as any).query = query;
    //     const { data: newData } = await refetch(variables);
    //     const newRows = newData[answerInfo.answerQueryType]?.edges.map((e: any) => e.node) ?? [];
    //     const newPageInfo = newData[answerInfo.answerQueryType]?.pageInfo ?? pageInfo;
    //     console.log("the new rows: ", newRows)
    //     console.log("the new page info: ", newPageInfo)
    //     setAnswers(prev => ({
    //         ...prev,
    //         answers: query ? newRows : [...(prev ?? []), ...newRows]
    //     }))
    //     setAnswerInfo(prev => ({
    //         ...prev,
    //         pageInfo: newPageInfo
    //     }))
    //     console.log(variables)

    // };

    // const refetchAnswers = (query: string | null | undefined) => {
    //     refetch({ query })
    // }
    // useEffect(() => {
    //     if (!data || loading) return;
    //     setAnswerInfo((prevState) => {
    //         return {
    //             ...prevState,
    //             totalAnswers: data?.[answerInfo.answerQueryType]?.totalCount,
    //             // pageInfo: data?.[answerInfo.answerQueryType]?.pageInfo
    //         }
    //     })
    //     const _answers = mapAnswersToTable(data, answerInfo.answerQueryType)
    //     setAnswers(_answers)
    // }, [data, loading])

    const value = useMemo(() => ({
        answers, setAnswers, answerInfo, setAnswerInfo, id, setId,
    }), [answers, answerInfo, id]);

    return (
        <AnswerContext.Provider value={value}>
            {children}
        </AnswerContext.Provider>
    )
}

export const useAnswerContext = () => {
    const context = useContext(AnswerContext);
    if (!context) {
        throw new Error("useSessionContext must be used within a SessionProvider");
    }
    return context;
};

function mapAnswersToTable(data: any, queryType: string) {
    const _answers = data?.[queryType]?.edges
    const mappedAnswers = _answers?.map((edge: any) => {
        const _answer = edge.node
        const parsedData = _answer?.data ? JSON.parse(_answer.data) : null;
        var finalParsedData
        if (_answer.question.language == "English" && _answer.question.questionSet == "TweenScreen") {
            if (_answer.question.id === WHO_DO_YOU_LIVE_WITH_ENGLISH_QUESTION_ID) {
                finalParsedData = `${splitCamelCase(parsedData.data.guardianType)}: ${splitCamelCase(parsedData.data.livingSituation)}`
            }
            else if (_answer.question.id === PARENT_DESCRIBE_THEIR_MOOD_ENGLISH_QUESTION_ID) {
                const extractedTraits = parsedData.data?.flatMap((parent: any) => parent.characteristics || [])
                finalParsedData = extractedTraits.join(", ") || "N/A"
            }

        }
        else {
        }
        return {
            id: _answer.id,
            questionPosition: _answer.question.position,
            screenLanguage: `${_answer.question.language} ${_answer.question.questionSet} `,
            question: _answer.question.title,
            questionType: _answer.question.type,
            category: _answer.question.category,
            data: finalParsedData ? finalParsedData : parsedData.skipped ? "Skipped question" : parsedData.notShown ? "Not Shown" : "N/A",
            sentimentAnalysisData: _answer?.sentimentAnalysisData,
            keywordExtractionData: _answer?.keywordExtractionData,
        }
    })

    return mappedAnswers
}
